import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import dashboardSidebarMenuBuilder from '../../components/DashboardSidebar/menuBuilder';

function IndexRedirect({ user, fetching }) {
  return (
    <Route
      exact
      path="/"
      render={() => {
        if (fetching) {
          return null;
        }

        // get the available side menu items for the logged in user
        const menuItems = dashboardSidebarMenuBuilder(user);
        if (menuItems.length === 0) {
          return null;
        }

        // redirect to the first menu entry
        return <Redirect to={menuItems[0].getUrl(user)} />;
      }}
    />
  );
}

IndexRedirect.propTypes = {
  user: PropTypes.object,
  fetching: PropTypes.bool,
};

const mapStateToProps = ({ user }) => ({
  user: user.currentUser,
  fetching: user.fetching,
});

export default connect(mapStateToProps)(IndexRedirect);
